import { useAiBoostStatus, useAiBoostPackages, useCreateAiBoostPayment } from '../../hooks/useMarketing'
import { Card, CardContent } from '../../components/ui/Card'
import { Button } from '../../components/ui/Button'
import { Zap, Check } from 'lucide-react'

export default function MarketingAiBoost() {
  const { data: status, isLoading } = useAiBoostStatus()
  const { data: packages } = useAiBoostPackages()
  const createPayment = useCreateAiBoostPayment()

  if (isLoading) return <div className="text-center py-12 text-gray-500">Memuat...</div>

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900 flex items-center gap-2">
          <Zap className="w-7 h-7 text-amber-500" /> AI Boost Store
        </h1>
        <p className="text-gray-600 mt-1">
          Beli AI Boost tambahan. Kredit tidak memiliki masa berlaku selama akun masih aktif.
        </p>
      </div>

      {status && (
        <Card className="bg-gradient-to-r from-amber-50 to-orange-50 border-amber-200">
          <CardContent className="pt-6">
            <div className="flex flex-wrap justify-between items-center gap-4">
              <div>
                <p className="text-sm text-amber-800 font-medium">Saldo AI Boost Anda</p>
                <p className="text-4xl font-black text-amber-900">{status.balance}</p>
                <p className="text-sm text-amber-700 mt-1">
                  Kuota tahunan: {status.yearlyRemaining}/{status.yearlyQuota} tersisa
                </p>
              </div>
              <div className="text-right text-sm text-amber-800">
                <p>Konsumsi AI:</p>
                <p>Caption / Banner = 1 kredit</p>
                <p>Campaign = 2 kredit</p>
              </div>
            </div>
            <div className="mt-4 h-3 bg-amber-100 rounded-full overflow-hidden">
              <div
                className="h-full bg-amber-500 rounded-full"
                style={{
                  width: `${status.yearlyQuota ? Math.min(100, (status.yearlyUsed / status.yearlyQuota) * 100) : 0}%`,
                }}
              />
            </div>
          </CardContent>
        </Card>
      )}

      <div className="grid md:grid-cols-3 gap-6">
        {packages?.map((pkg) => (
          <Card key={pkg.id} className={pkg.id === 'growth' ? 'border-indigo-300 ring-2 ring-indigo-100' : ''}>
            <CardContent className="pt-6">
              {pkg.id === 'growth' && (
                <span className="text-xs font-bold text-indigo-600 bg-indigo-50 px-2 py-1 rounded-full">Populer</span>
              )}
              <h3 className="text-xl font-bold mt-2">{pkg.name}</h3>
              <p className="text-3xl font-black text-gray-900 mt-2">
                Rp {pkg.price.toLocaleString('id-ID')}
              </p>
              <p className="text-lg font-semibold text-amber-600 mt-1">{pkg.credits} AI Boost</p>
              <p className="text-sm text-gray-600 mt-3">{pkg.description}</p>
              <ul className="mt-4 space-y-2">
                <li className="flex items-center text-sm text-gray-700">
                  <Check className="w-4 h-4 text-green-500 mr-2" /> Tanpa masa berlaku
                </li>
                <li className="flex items-center text-sm text-gray-700">
                  <Check className="w-4 h-4 text-green-500 mr-2" /> Langsung ditambahkan ke saldo
                </li>
              </ul>
              <Button
                className="w-full mt-6 bg-indigo-600 hover:bg-indigo-700 text-white"
                onClick={() => createPayment.mutate(pkg.id)}
                disabled={createPayment.isPending}
              >
                Beli Sekarang
              </Button>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  )
}
